export const MAX_FILE_SIZE_MB = 2;

export enum FileUploadStatuses {
  READY = 'READY',
  COMPLETE = 'COMPLETE',
  LOADING = 'LOADING',
  FAILED = 'FAILED'
}
